import { action } from "typesafe-actions";

import { message } from "antd";

import { User, UserActionTypes } from "./types";

export const userFetchRequest = (gateId?: number) => action(UserActionTypes.FETCH_REQUEST, gateId);

export const userFetchSuccess = (payload: { user: User; gateId?: number }) =>
  action(UserActionTypes.FETCH_SUCCESS, payload);

export const userFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(UserActionTypes.FETCH_ERROR);
};

export const userSelectGate = (gateId: number) => action(UserActionTypes.SELECT_GATE, gateId);
